import { z } from "zod";
import { TypePays } from "../enums/type-pays.enum";

export const createPetiteAnnonceSchema = z
  .object({
    personneMorale: z.boolean(),
    raisonSociale: z.string().trim(),
    categorieId: z.string().trim().min(1, "Veuillez sélectionner une catégorie."),
    nom: z.string().trim().min(1, "Requis"),
    prenom: z.string().trim().min(1, "Requis"),
    adresse1: z.string().trim().min(1, "Requis"),
    adresse2: z.string().trim(),
    codePostal: z.string().trim().min(1, "Requis"),
    ville: z.string().trim().min(1, "Requis"),
    telephone: z.string().trim().min(1, "Requis"),
    ligne1: z.string().trim().min(1, "Requis"),
    ligne2: z.string().trim(),
    ligne3: z.string().trim(),
    ligne4: z.string().trim(),
    ligne5: z.string().trim(),
    ligne6: z.string().trim(),
    tramage: z.boolean(),
    mois: z.array(z.string()).min(1, "Renseignez au moins un mois de parution"),
    typePays: z.nativeEnum(TypePays),
    pays: z.string().trim(),
    noTva: z.string().trim(),
    siret: z.string().trim(),
  })
  .superRefine((data, ctx) => {
    if (data.personneMorale && !data.raisonSociale) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: "Requis", path: ["raisonSociale"] });
    }
    if (data.typePays !== TypePays.FRANCE && !data.pays) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: "Requis", path: ["pays"] });
    }
  });
export type CreatePetiteAnnonceDto = z.infer<typeof createPetiteAnnonceSchema>;
